import { render, staticRenderFns } from "./ModalDesc.vue?vue&type=template&id=a1aa6828&scoped=true&"
import script from "./ModalDesc.vue?vue&type=script&lang=js&"
export * from "./ModalDesc.vue?vue&type=script&lang=js&"
import style0 from "./ModalDesc.vue?vue&type=style&index=0&id=a1aa6828&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1aa6828",
  null
  
)

export default component.exports